<template>
	<div>
		<b-card-body>
			<b-media>
				<template v-slot:aside>
					<img id="avatar" :src="image" alt="Character image">
				</template>
				<h4 class="mt-0">{{Name}}</h4>
				<p class="lead">{{Gender}} {{Race}} {{Theme}} {{Description}}</p>
			</b-media>
		</b-card-body>
		<div class="p-0 mb-1">
			<b-progress variant="warning" v-if="TempHP.Active" :max="TempHP.Max">
				<b-progress-bar :value="TempHP.HP">
					Temp HP: {{TempHP.HP}}/{{TempHP.Max}}
				</b-progress-bar>
			</b-progress>
			<b-progress variant="danger" :max="totalHP">
				<b-progress-bar :value="HP">
					HP: {{HP}}/{{totalHP}}
				</b-progress-bar>
			</b-progress>
			<b-progress variant="success" :max="totalSP">
				<b-progress-bar :value="SP">
					SP: {{SP}}/{{totalSP}}
				</b-progress-bar>
			</b-progress>
			<b-progress variant="primary" :max="totalRP">
				<b-progress-bar :value="RP">
					RP: {{RP}}/{{totalRP}}
				</b-progress-bar>
			</b-progress>
		</div>
		<div class="card-body p-1">
			<div class="row justify-content-between" style="padding-left: 15px!important; padding-right:15px!important;">
				<div class="px-1 mb-1 flex-fill">
					<button class="btn input-group-text btn-block has-icon" @click="showVitals()">
						<font-awesome-icon icon="heart-broken"></font-awesome-icon>&nbsp;Vitals
					</button>
				</div>
				<div class="px-1 mb-1 flex-fill">
					<button class="btn input-group-text btn-block has-icon"  @click="round()">
						<font-awesome-icon icon="redo"></font-awesome-icon>&nbsp;Round
					</button>
				</div>
				<div class="px-1 mb-1 flex-fill">
					<button class="btn input-group-text btn-block has-icon" @click="shortRest()">
						<font-awesome-icon icon="stopwatch"></font-awesome-icon>&nbsp;10-min
					</button>
				</div>
				<div class="px-1 mb-1 flex-fill">
					<button class="btn input-group-text btn-block has-icon" @click="longRest()">
						<font-awesome-icon icon="procedures"></font-awesome-icon>&nbsp;Rest
					</button>
				</div>
			</div>
			<div class="row justify-content-between" style="padding-left: 15px!important; padding-right:15px!important;">
				<div class="col-12 col-sm-6 col-md-4 px-1 mb-1 item">
					<div class="input-group">
						<div class="input-group-prepend">
							<button class="input-group-text number" onClick="$('#vitals-wizard').modal('show');">HP</button>
						</div>
						<input type="number" class="form-control" v-model.number="HP" min="0" :max="totalHP">
						<div class="input-group-append">
							<span class="input-group-text">{{totalHP}}</span>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-4 px-1 mb-1 item">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text number">SP</span>
						</div>
						<input type="number" class="form-control" v-model.number="SP" min="0" :max="totalSP">
						<div class="input-group-append">
							<span class="input-group-text">{{totalSP}}</span>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-4 px-1 mb-1 item">
					<div class="input-group">
						<div class="input-group-prepend">
							<button class="input-group-text number has-icon" @click="showRPAdjust()"><font-awesome-icon icon="pencil-alt"></font-awesome-icon>RP</button>
						</div>
						<input type="number" class="form-control" v-model.number="RP" min="0" :max="totalRP">
						<div class="input-group-append">
							<span class="input-group-text">{{totalRP}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	computed: {
		...mapState({
			Name: state => state.Character.Bio['Character Name'],
			Gender: state => state.Character.Bio.Gender,
			Race: state => state.Character.Bio.Race.Name,
			Theme: state => state.Character.Bio.Theme,
			Description: state => state.Character.Bio.ShortDescription,
			TempHP: state => state.Character.Current.Points.Temporary,

		}),
		...mapState('character/bio',[
			'image',
		]),
		...mapGetters('character/status',[
			'totalHP',
			'totalSP',
			'totalRP',
		]),
		HP: {
			get: function() {
				return this.$store.getters['character/status/currentHP']
			},
			set: function(value) {
				this.$store.dispatch('character/status/setHP',value)
			}
		},
		SP: {
			get: function() {
				return this.$store.getters['character/status/currentSP']
			},
			set: function(value) {
				this.$store.dispatch('character/status/setSP',value)
			}
		},
		RP: {
			get: function() {
				return this.$store.getters['character/status/currentRP']
			},
			set: function(value) {
				this.$store.dispatch('character/status/setRP',value)
			}
		},
	},
	methods: {
		round: function() {
			this.$store.dispatch('character/status/refreshTempHP')
		},
		shortRest: function() {
			this.$store.dispatch('character/status/restShort')
		},
		longRest: function() {
			this.$store.dispatch('character/status/restLong')
		},
		showVitals: function() {
			this.$store.commit('modals/show','vitals')
		},
		showRPAdjust: function() {
			this.$store.commit('modals/show','numeric')
		}
	}
}
</script>

<style scoped>
	#avatar {
		max-width: 150px;
	}

	.progress {
		border-radius: 0px;
	}
	.flex-fill {
		flex: 1 1 auto!important;
	}
	.has-icon svg {
		margin-right: 5px;
	}
</style>